
function AliasMap() {
    var aliases = {};

    this.establish  = function establish(topic) {
        var bang = topic.indexOf('!');

        if (bang !== -1) {
            if (bang === 0) {
                // Alias only, look up topic name from hash.
                return aliases[topic.substring(1)];
            } else {
                // Topic and alias
                var alias = topic.substring(bang + 1);
                topic = topic.substring(0, bang);
                
                aliases[alias] = topic;

                return topic;
            }
        } else {
            return topic;
        }
    };
}

AliasMap.create = function() {
    return new AliasMap();
};

module.exports = AliasMap;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/v4-stack/aliases.js
// module id = 1088
// module chunks = 1